module.exports = __webpack_public_path__ + "img/galeria-19.b8ce918f.jpg";